<template>
	<v-dialog
		v-model="visible"
		width="auto"
		max-width="calc(90%)"
		min-width="600"
		persistent
	>
		<v-alert type="error" class="mb-0" v-if="error_msg.length !== 0">{{
			error_msg
		}}</v-alert>
		<EditReceipt
			:color="color" 
			:currencies="currencies" 
			:phases="phases"
			:receipt="receipt_local"
			:loading="loading"
			:isFinance="isFinance"
			:isDuplicate="isDuplicate"
			:isMultiDuplicate="isMultiDuplicate"
			:errorMessage="errorMessage"
			@close="close_receipt($event)"
			@save="save_receipt($event)"
			@cancel="cancel_receipt($event)"
			@copy="copy_receipt($event)"
			@more="$emit('more')"
			@update-file="$emit('update-file', $event)"
		/>
	</v-dialog>
</template>

<script>
import EditReceipt from "@/views/expenses/commond/edit_receipt";

export default {
	name: 'EditReceiptDialog',
	props: {
		color: {
			type: String,
			default: ""
		},
		currencies: {
			type: Array,
			default: () => {},
		},
		visible: {
			type: Boolean,
			default: false,
		},
		receiptId: {
			type: Number,
			default: null,
		},
		receipt: {
			type: Object,
			default: () => {},
		},
		loading: {
			type: Boolean,
			default: false,
		},
		isFinance: {
			type: Boolean,
			default: false,
		},
		isDuplicate: {
			type: Boolean,
			default: false,
		},
		isMultiDuplicate: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: ''
		}
	},
	components: {
		EditReceipt,
	},
	data() {
		return {
			error_msg: '',
			receipt_local: null,
			phases: [],
		}
	},
	created() {
		if (this.receiptId) {
			this.load_receipt(this.receiptId);
		} else {
			this.receipt_local = {
				...this.receipt,
				id: Number(this.receipt.id) >= 0 && this.receipt.receipt_id !== undefined
					? this.receipt.receipt_id
					: this.receipt.id,
			};

			if (this.receipt.job) {
				this._getPhase(this.receipt.job.id);
			}
		}
	},
	watch: {
		receiptId() {
			if (this.receiptId) {
				this.load_receipt(this.receiptId);
			}
		},
		receipt() {
			if (this.receipt) {
				this.receipt_local = {
					...this.receipt,
					id: Number(this.receipt.id) >= 0 && this.receipt.receipt_id !== undefined
						? this.receipt.receipt_id
						: this.receipt.id,
				};

				if (this.receipt.job) {
					this._getPhase(this.receipt.job.id);
				}
			}
		}
	},
	methods: {
		async load_receipt(id) {
			let url = "/api/expenses/receipts/" + id;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.job) {
							this._getPhase(data.job.id);
						}
						this.receipt_local = data;
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message
				});
		},
		close_receipt() {
			this.$emit('close');
		},
		save_receipt(save_receipt) {
			this.$emit('save', save_receipt);
		},
		cancel_receipt(receipt_id) {
			this.$emit('cancel', receipt_id);
		},
		copy_receipt(receipt) {
			this.$emit('copy', receipt);
		},
		_getPhase(job_id) {
			axios.get('/api/jobs/' + job_id + '/phases', {
				headers: {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"
				}
			})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.phases = data;

					} else {
						this.error_msg = reason;
					}

				})
				.catch(msg => {
					this.error_msg = msg;
				})
		},
	}
}
</script>
<style lang="scss" scoped>
.dialog {
	display: flex;
	flex-flow: row nowrap;
	justify-content: center;
	align-items: center;
}
</style>